import { useAtom, useAtomValue } from "jotai";
import { useCallback } from "react";
import {
  isLoadingTasksAtom,
  isLoadingPreferencesAtom,
  isLoadingUserDataAtom,
  isLoadingAtom,
} from "../../store/atoms/asyncAtoms.js";

export const useLoading = () => {
  const [isLoadingTasks, setIsLoadingTasks] = useAtom(isLoadingTasksAtom);
  const [isLoadingPreferences, setIsLoadingPreferences] = useAtom(
    isLoadingPreferencesAtom
  );
  const [isLoadingUserData, setIsLoadingUserData] = useAtom(
    isLoadingUserDataAtom
  );
  const isLoading = useAtomValue(isLoadingAtom);

  const withLoading = useCallback((loadingAtom, asyncFunction) => {
    return async (...args) => {
      loadingAtom(true);
      try {
        const result = await asyncFunction(...args);
        return result;
      } finally {
        loadingAtom(false);
      }
    };
  }, []);

  const withTaskLoading = useCallback(
    (asyncFunction) => withLoading(setIsLoadingTasks, asyncFunction),
    [withLoading, setIsLoadingTasks]
  );

  const withPreferenceLoading = useCallback(
    (asyncFunction) => withLoading(setIsLoadingPreferences, asyncFunction),
    [withLoading, setIsLoadingPreferences]
  );

  const withUserLoading = useCallback(
    (asyncFunction) => withLoading(setIsLoadingUserData, asyncFunction),
    [withLoading, setIsLoadingUserData]
  );

  return {
    isLoading,
    isLoadingTasks,
    isLoadingPreferences,
    isLoadingUserData,
    setIsLoadingTasks,
    setIsLoadingPreferences,
    setIsLoadingUserData,
    withTaskLoading,
    withPreferenceLoading,
    withUserLoading,
  };
};
